<template>
  <div class="ContentTile__container">
    <div v-if="masterclass" :class="['ContentTile', classColor, ['mobile', 'tablet'].includes($mq) ? 'ContentTile--Mobile': '']">
      <download-button class="DownloadButton" v-if="hasAccessToContent(masterclassId) && !isUnavailable && !isLocked && $mq == 'desktop'" content-type="theme" :content-id="this.masterclassId" />
      
      <!-- Main body (Card) -->
      <div :class="{ Body: true, 'Body--mobile': ['mobile', 'tablet'].includes($mq) }" @click="onClick">
        <div v-if="isUnavailable" class="UnavailableOverlay">{{ t('unavailable') }}</div>
        <!-- Lock overlay -->
        <div v-if="isLocked && !isUnavailable" class="LockedOverlay">
          <img class="Lock" src="@/assets/Cadenas@2x.png" />
        </div>
        <div v-if="isUnavailable" class="LockedOverlay">
          <img class="Lock Lock-Unavailable" src="@/assets/time-glass.png" />
        </div>

        <!-- Background and darker overlay -->
        <div class="Background" :style="{ 'background-image': background }">
          <div class="Shader" />
        </div>

        <!-- Title -->
        <!-- <div class="Title">
          {{ masterclass.title }}
        </div> -->

        <!-- Progression (if in progress) -->
        <!-- <vv-completion v-if="completion > 0 && !isLocked && isPending" class="Completion" :percentage="completion" /> -->

        <!-- Author -->
        <!-- <div class="Author" v-if="!['mobile', 'tablet'].includes($mq) && authorPresent && !isUnavailable">
          <div class="Author__Portrait">
            <img class="Portrait" :src="authorPortrait" :alt="authorIdentity" />
          </div>
          <div class="Author__Identity">
            <div class="Name">
              {{ t('authorPrefix') }}<strong>{{ authorIdentity }}</strong>
            </div>
            <div class="Job">
              {{ authorJob }}
            </div>
          </div>
        </div> -->
      </div>

      <!-- Action button -->
      <div class="ButtonContainer">
        <div class="Button" @click="onClick">
          {{ buttonLabel }}
        </div>
      </div>
    </div>

    <!-- Price tag information -->
    <div v-if="!isUnavailable" :class="{ Price: true, 'Price--free': !isPremium }">
      <div :class="['mobile', 'tablet'].includes($mq) ? 'Title-Mobile': 'Title'">{{ masterclass.title }}</div>
      <div :class="[['mobile', 'tablet'].includes($mq) ? 'Amount-Mobile' : 'Amount', !isLocked && isPremium ? 'Amount-Payed': '']">{{ isLocked && isPremium ? t('price', { price }) : !isLocked && isPremium ? t('payed') : t('free') }}</div>
    </div>
    <div v-if="isUnavailable" :class="{ Price: true, 'Price--free': !isPremium && !isUnavailable }">
      <div :class="['mobile', 'tablet'].includes($mq) ? 'Title-Mobile': 'Title'">{{ masterclass.title }}</div>
      <div :class="['mobile', 'tablet'].includes($mq) ? 'Amount-Mobile' : 'Amount'">{{ t('unavailable') }}</div>
    </div>
  </div>
</template>

<script>
import _get from 'lodash/get'

import { mapGetters } from 'vuex'

import { VvCompletion } from '@/components/common'
import DownloadButton from '@/components/download/DownloadButton'
import { getThemePercentage } from '@/helpers/userCompletion'
import contentMixin from '@/mixins/content'

export default {
  name: 'ContentTile',
  components: { VvCompletion, DownloadButton },
  mixins: [contentMixin],
  props: {
    masterclassId: {
      type: String,
      required: true
    },
    hidePrice: {
      type: Boolean
    },
    isPending: {
      type: Boolean
    },
    classColor: {
      type: String,
      default: 'primary-color'
    }
  },
  computed: {
    ...mapGetters([
      'getThemes',
      'getThemeById'
    ]),
    masterclass() {
      return this.getThemeById(this.masterclassId)
    },
    background() {
      return `url(${this.masterclass.tileImage})`
    },
    completion() {
      return getThemePercentage(this.masterclassId)
    },
    buttonLabel() {
      if(this.completion > 0 && !this.isLocked)
        return this.t('continue')
      else if (this.isLocked)
        return this.t('checkMore')
      else return this.t('begin')
    },
    authorPresent() {
      return this.masterclass.author ? this.masterclass.author.present : false
    },
    authorIdentity() {
      return this.masterclass.author && this.masterclass.author.fullName != '' ? this.masterclass.author.fullName : null
    },
    authorPortrait() {
      return this.masterclass.author && this.masterclass.author.image != '' ? this.masterclass.author.image : null
    },
    authorJob() {
      return this.masterclass.author && this.masterclass.author.job != '' ? this.masterclass.author.job : null
    },
    isUnavailable() {
      return this.masterclass.author && this.masterclass.author.fullName === 'PENDING' ? true : false
    },
    isPremium() {
      return this.masterclass.premium
    },
    isLocked() {
      return !this.hasAccessToContent(this.masterclassId)
    },
    price() {
      // @baptiste
      return '19,90€'
    }
  },
  methods: {
    t(key, params) {
      return this.$t(`masterclass-content-tile.${key}`, params)
    },
    onClick() {
      this.$emit('click', { id: this.masterclass.id, locked: this.isLocked })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';
@import '@/assets/styles/responsive.scss';

.ContentTile__container {
  margin-bottom: 50px;

  @media screen and (max-width: 320px) {
    width: calc(100% - 10px);
  }
}

.ContentTile {
  position: relative;
  display: block;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;
  height: 285px;
  width: 320px;

  .DownloadButton {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 10;
  } 

  @media screen and (max-width: 1350px) {
    height: 265px;
    width: 300px;
  }
  // @media screen and (max-width: 1050px) {
  //   height: 200px;
  //   width: 220px;
  // }
  // min-width: 300px;
  transition: all 1s ease-in-out;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;

  &.ContentTile--Mobile {
    height: 150px;
    width: 200px;

    .DownloadButton {
      display: hidden;
    } 
  }

  &:hover {
    cursor: pointer;
    transform: scale(1.05);
  }

  &.primary-color:hover {
    .Body {
      .Name strong {
        color: $primary !important;
      }

      .Title {
        color: $primary !important;
      }
    }
  }

  &.bleu-color:hover {
    .Body {
      .Name strong {
        color: #39CFEB !important;
      }

      .Title {
        color: #39CFEB !important;
      }
    }
  }

  &.vert-color:hover {
    .Body {
      .Name strong {
        color: #57B57F !important;
      }

      .Title {
        color: #57B57F !important;
      }
    }
  }

  &.orange-color:hover {
    .Body {
      .Name strong {
        color: #F69E34 !important;
      }

      .Title {
        color: #F69E34 !important;
      }
    }
  }

  &.rouge-color:hover {
    .Body {
      .Name strong {
        color: #FC4747 !important;
      }

      .Title {
        color: #FC4747 !important;
      }
    }
  }

  @media screen and (max-width: 320px) {
    width: 250px;
  }

  .Body {
    position: relative;
    border-radius: 20px;
    overflow: hidden;
    height: 100%;
    z-index: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .Background {
      position: absolute;
      z-index: -1;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-repeat: no-repeat;
      background-size: cover;

      .Shader {
        position: absolute;
        z-index: -1;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }
    }

    .Title {
      color: white;
      font-weight: bold;
      font-family: Helvetica, sans-serif;
      font-size: 24px;
      text-align: center;
    }

    .Completion {
      margin-top: 10px;
      width: 65%;
    }

    .Author {
      display: flex;
      width: 100%;
      margin-top: 30px;
      margin-bottom: -20px;
      padding: 10px 0px;
      justify-content: center;
      align-items: center;
      background-color: $primary-alt;

      .Author__Portrait {
        width: 80px;
        height: 80px;
        margin-top: -30px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-left: 10px;
      }

      .Portrait {
        width: inherit;
        height: inherit;
        border-radius: 100%;
        overflow: hidden;
      }

      .Author__Identity {
        width: 60%;
        margin-left: 20px;
        padding-right: 10px;
      }

      .Name {
        margin-bottom: 3px;
      }

      .Job {
        font-size: 12px;
      }
    }

    .LockedOverlay {
      display: flex;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      z-index: 10;
      background-color: rgba(0, 0, 0, 0.4);
      justify-content: center;
      align-items: center;
      height: 100%;

      .Lock {
        height: 100px;
      }

      .Lock-Unavailable {
        height: 125px;
      }
    }

    .UnavailableOverlay {
      background-color: $primary;
      color: white;
      width: 100%;
      height: 50px;
      z-index: 20;
      position: absolute;
      top: 0px;
      display: inline-block;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
    }

    &--mobile {

      .Title {
        font-size: smaller;
        padding-left: 10px;
        padding-right: 10px;
      }

      .Lock {
        height: 80px !important;
      }

      .Lock-Unavailable {
        height: 100px !important;
      }

      .UnavailableOverlay {
        height: 30px;
        top: -55px;
      }
    }

  }

  .ButtonContainer {
    position: absolute;
    bottom: -15px;
    width: 100%;
    text-align: center;
    user-select: none;

    .Button {
      cursor: pointer;
      display: inline-block;
      padding: 7.5px 15px;
      background-color: $primary;
      font-weight: bold;
      color: white;
      border-radius: 23px;
      font-size: 12px;
      text-transform: uppercase;
    }
  }
}

.Price {
  margin-top: 30px;
  text-align: center;

  .Title {
    font-weight: bold;
    color: black;
    margin-bottom: 5px;
  }

  .Title-Mobile {
    font-weight: bold;
    color: black;
    margin-bottom: 5px;
    font-size: x-small;
  }

  &--free {
    color: $primary;
  }

  .Amount {
    font-size: 14px;
  }
  .Amount-Mobile {
    font-size: xx-small;
  }
  .Amount-Payed {
    color: $font-color-light;
    // font-weight: bold;
  }
}
</style>
